export default function Breadcrumbs() {
  return null;
}
